import { createContext } from "react";

const CurrentContext = createContext({
  current: "",
});

export default CurrentContext;
